import styled from "styled-components";
import color from "../../assets/css/colors";
import { AccordionBodyInterface } from "./interfaces";

export const IconChange = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
`

export const Img = styled.img``

export const ImgAccordion = styled.img`
    width: 100%;
`


export const Text = styled.p``

export const Box = styled.div``

export const AccordionTitle = styled.p`
    font: normal normal normal 14px/20px Circular Std Book;
    margin: 0px;
    color: ${color.tertiary};
`

export const ImageModal = styled.img`
    width: 90%;

    @media (max-width: 900px) {
        width: 100%;
    }
`

export const Center = styled.div`
    display: flex;
    align-items: center;
`

export const Container = styled.div`
    margin-bottom: 17px;
    padding-bottom: 2px;
    border-bottom: 1px solid ${color.ballonBackground};

    &:hover {
        cursor: pointer;
    }
`

export const BtnCloseModal = styled.img`
    width: 24px;
    position: absolute;
    right: 16px;
    background: ${color.white};
    top: 16px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0px 5px 10px 0px ${color.grayLighter}; 
    &:hover {
        transform: scale(1.1);
    }

    @media (max-width: 600px) {
        width: 16px;
        top: 8px;
        right: 8px;
    }
`

export const AccordionBody = styled.div`
    margin-top: 9px;
    margin-left: 14px;
    border-left-style: solid;
    border-left-width: 3px;
    border-left-color: #FFCD8B;
    display: ${(p: AccordionBodyInterface) => p.visible ? "block" : "none"};
`

export const AccordionBodyContent = styled.div`
    margin-left: 10px;
    padding-top: 9px;
    padding-bottom: 9px;

    .btnSeeTour {
        font-size: 0.7rem;
        padding: 7px 10px;
        width: 100px;
        border-radius: 8px;
    }

    @media (max-width: 600px) {
        .btnSeeTour {
            font-size: 0.5rem;
            padding: 5px 8px;
            width: 80px;
            border-radius: 8px;
        }
    }
`;